import { render } from "./LinkReport.vue?vue&type=template&id=5d311f6f&scoped=true"
import script from "./LinkReport.vue?vue&type=script&lang=js"
export * from "./LinkReport.vue?vue&type=script&lang=js"

import "./LinkReport.vue?vue&type=style&index=0&id=5d311f6f&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d311f6f"]])

export default __exports__